export default "__VITE_ASSET__DjCvYYSp__"